module.exports = __webpack_public_path__ + "img/box_SMRAT_ANIMATED.cd7d118a.svg";